import { CTAButton } from "@circle-react-shared/EditorContentBlocks/CTAButton";
import { getCurrentRange } from "@circle-react-shared/uikit/TipTapBlockEditor/Toolbar/helpers";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import type { Editor } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";

import { classNames } from "@/react/helpers/twMergeWithCN";

import { CTAOptions } from "./CTAOptions";
import { useCTASettingsModal } from "./CTASettingsModal";

interface RendererProps {
  deleteNode: () => void;
  editor: Editor;
  node: any;
  selected: boolean;
  updateAttributes: any;
}

export const Renderer = ({
  editor,
  node,
  updateAttributes,
  deleteNode,
  selected,
}: RendererProps) => {
  const isEditable = editor.isEditable;
  const ctaSettingsModal = useCTASettingsModal();
  const { isWithinEmailEditor } = useBlockEditorContext() || {};

  const handleCtaClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isEditable) return;

    event.preventDefault();
    ctaSettingsModal
      .show({
        editor,
        range: getCurrentRange({ editor }),
        isWithinEmailEditor,
      })
      .catch(console.error);
  };

  return (
    <NodeViewWrapper
      as="div"
      className={classNames(
        "group relative my-2 flex items-center rounded-md border py-4",
        {
          "justify-center": node.attrs.alignment === "center",
          "justify-start": node.attrs.alignment === "left",
          "justify-end": node.attrs.alignment === "right",
        },
        {
          "border-transparent": !isEditable,
          "hover:border-dark border-transparent": isEditable && !selected,
          "border-circle": isEditable && selected,
        },
      )}
    >
      <CTAButton
        color={node.attrs.color}
        textColor={node.attrs.text_color}
        isFullWidth={Boolean(node.attrs.full_width)}
        mayLeadToPurchase={node.attrs.may_lead_to_purchase === true}
        url={node.attrs.url}
        onClick={handleCtaClick}
      >
        {node.attrs.label}
      </CTAButton>
      {isEditable && (
        <CTAOptions
          editor={editor}
          node={node}
          updateAttributes={updateAttributes}
          deleteNode={deleteNode}
        />
      )}
    </NodeViewWrapper>
  );
};
